import React from 'react';
import { Button, Icon, Modal } from '../../../../../shared/ui';
import { IconMap } from '../../../../../shared/sprite';
import { useDispatch, useSelector } from 'react-redux';
import { integrationsModel } from '../../../../../entities/integrations';

type Props = {
  isOpen: boolean;
  onClose(): void;
};

export const SalesforceDetailsModal: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {
  const dispatch = useDispatch();

  const isConnectingToSalesforce = useSelector(
    integrationsModel.selectors.selectIsConnectingToSalesforce
  );

  const handleConnect = () => {
    dispatch(
      integrationsModel.actions.connectToSalesforce({
        cb: onClose,
      })
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isShowCancelButton={false}
      className="w-120"
    >
      <div className="flex items-start justify-between w-full">
        <Icon glyph={IconMap.Salesforce} width={48} />
        <Button color="transparent" variant="icon" onClick={onClose} size="sm">
          <Icon glyph={IconMap.XClose} width={24} className="text-gray-400" />
        </Button>
      </div>

      <div className="text-display-xs font-display text-gray-900 font-medium mt-4 mb-5">
        Salesforce integration
      </div>
      <p className="text-sm text-gray-600 mb-5">
        Once the integration is connected, your page activity will automatically
        sync and attach as a completed Task on any matching Contacts, Accounts,
        and Opportunities. Matching is based on the users email and name.
        <br />
        Distribute does not connect to Leads in Salesforce - only Contacts,
        Accounts, and Opportunities.
      </p>
      <Button
        color="primary"
        variant="text"
        className="w-45"
        onClick={handleConnect}
        loading={isConnectingToSalesforce}
      >
        Connect Salesforce
      </Button>
    </Modal>
  );
};
